<div class="layout-topbar"
    [ngClass]="{
        'border-bottom-none': layoutService.config().topbarTheme !== 'light'
    }"
>
    <div class="layout-topbar-start">
        <div style="display: flex;   justify-content: flex-start; align-items: center; ">
        <a
            #mobileMenuButton
            class="layout-menu-button lg:hidden"
            (click)="onMenuButtonClick()"
            pRipple
        >
            <i class="pi pi-bars"></i>

        </a><a class="lg:hidden ml-2" style="color: black; text-decoration: none; font-weight: bold" routerLink="{{dashboard_link}}">
                {{ 'Pannello' | translate }}
            </a>
        </div>
        <div class="layout-topbar-actions-start mr-4">
            <a
                    *ngIf="!layoutService.isHorizontal()"
                    #menuButton
                    class="layout-menu-button hidden lg:flex"
                    (click)="onMenuButtonClick()"
                    pRipple
            >
                <i class="pi pi-bars"></i>
            </a>
        </div>
        <a *ngIf="isInternalLink(dashboard_link)" class="layout-topbar-logo hidden lg:block" style="color: black; text-decoration: none; font-weight: bold" routerLink="{{dashboard_link}}">
            {{ 'Pannello' | translate }}
        </a>
        <a *ngIf="!isInternalLink(dashboard_link)" class="layout-topbar-logo hidden lg:block" style="color: black; text-decoration: none; font-weight: bold" href="{{dashboard_link}}">
            {{ 'Pannello' | translate }}
        </a>
        <a
            class="lg:hidden"
            pStyleClass="@next"
            enterFromClass="hidden"
            enterActiveClass="scalein"
            leaveToClass="hidden"
            leaveActiveClass="fadeout"
            [hideOnOutsideClick]="true"
        >
            <i class="pi pi-user" style="font-size: 2.5rem"></i>

        </a>
        <div class="layout-topbar-menu shadow-2 px-3 hidden" style="top: 9rem">
            <ul class="list-none p-0 m-0">
                <li class="mb-2">
                    <div class="flex gap-3 p-3 bg-primary-600">
                        <i class="pi pi-user" style="font-size: 2.5rem"></i>

                        <div class="flex flex-column cursor-pointer">
                            <span class="font-semibold text-white">{{ nome }}</span>
                            <span class="text-xs font-normal text-white">{{ ruolo | translate }}</span>
                        </div>
                    </div>
                </li>

                <li class="py-3 px-4 cursor-pointer">
                    <a (click)="goToProfilo()" class="flex items-center gap-2 w-full h-full" >
                        <i class="pi pi-star text-lg"></i>
                        <span class="font-semibold mx-3">{{ 'Dati personali' | translate }}</span>
                    </a>
                </li>

                <li class="py-3 px-4 cursor-pointer" *ngIf="this.ruolo != 'paziente'">
                    <a (click)="goToCambiapassword()" class="flex items-center gap-2 w-full h-full">
                        <i class="pi pi-key text-lg"></i>
                        <span class="font-semibold mx-3">{{ 'Cambia password' | translate }}</span>
                    </a>
                </li>

                <li class="py-3 px-4 flex gap-2 cursor-pointer" *ngIf="this.ruolo == 'paziente'">
                    <a  (click)="goToModificaConsensi()">
                        <i class="pi pi-file text-lg mr-3"></i>
                        <span class="font-semibold">{{ 'Modifica consensi' | translate }}</span>
                    </a>
                </li>

                <li class="py-3 px-4 flex gap-2 cursor-pointer" *ngIf="this.ruolo == 'paziente'">
                    <a (click)="goToPrivacyConsulto()">
                        <i class="pi pi-eye-slash text-lg mr-3"></i>
                        <span class="font-semibold">{{ 'Privacy del consulto' | translate }}</span>
                    </a>
                </li>

                <li class="py-3 px-4 flex gap-2 cursor-pointer" *ngIf="this.ruolo == 'paziente'">
                    <a>
                        <i class="pi pi-flag text-lg mr-3"></i>
                        <span class="font-semibold">{{ 'Lingua' | translate }}</span>&nbsp;
                        <select [(ngModel)]="selectedLanguage"  (change)="onLanguageChange($event)">
                            <option value="it">🇮🇹 Italiano</option>
                            <option value="en">🇬🇧 English</option>
                        </select>
                    </a>

                 </li>

                <li class="py-3 px-4 flex gap-2 cursor-pointer">
                    <a (click)="logout()">
                        <i
                                class="pi pi-power-off pi-image text-lg"
                        ></i>
                        <span class="font-semibold mx-3"
                        >{{ 'Esci' | translate }}</span
                        >
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div class="layout-topbar-end surface-border flex">
        <div class="layout-topbar-actions-start">
&nbsp;
        </div>
        <div class="flex flex-grow">
            <a routerLink="{{dashboard_link}}">
            <img style="max-height: 40px;"
                [src]="
                    'assets/layout/images/logo-' +
                    (layoutService.config().topbarTheme === 'light'
                        ? 'poseidon'
                        : 'poseidon-dark') +
                    '.png'
                "
                alt="poseidon-layout"
        /></a></div>
        <div class="layout-topbar-actions-end">
            <ul class="layout-topbar-items">
<!--                <li class="layout-topbar-search hidden lg:flex">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" placeholder="Search..." />
                </li>
                <li class="lg:hidden">
                    <a
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="fadeout"
                        [hideOnOutsideClick]="true"
                        pRipple
                    >
                        <i class="pi pi-search"></i>
                    </a>
                    <div
                        class="layout-topbar-search hidden absolute origin-top surface-overlay p-2 border-top-1 surface-border shadow-2"
                        style="top: 3.5rem"
                    >
                        <span class="p-input-icon-left w-full">
                            <i class="pi pi-search"></i>
                            <input
                                type="text"
                                pInputText
                                placeholder="Search"
                                class="w-full"
                            />
                        </span>
                    </div>
                </li>-->
                <!-- Notifiche <li>
                    <a
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="fadeout"
                        [hideOnOutsideClick]="true"
                        pRipple
                    >
                        <i class="pi pi-bell" pBadge value="2"></i>
                    </a>
                    <div class="layout-topbar-menu shadow-2 pt-0 hidden">
                        <ul class="list-none p-0 m-0">
                            <li
                                class="flex justify-content-between align-items-center px-3 p-3 mb-3 cursor-pointer"
                            >
                                <h6 class="m-0 font-semibold">Notifications</h6>
                                <span class="p-badge">3</span>
                            </li>
                            <li>
                                <a
                                    class="py-2 px-3 flex gap-2 cursor-pointer hover:text-primary"
                                >
                                    <div
                                        class="flex align-items-center justify-content-center border-1 border-circle border-transparent bg-blue-100 text-500"
                                        style="height: 30px; width: 30px"
                                    >
                                        <i
                                            class="pi pi-shopping-cart text-lg text-blue-500"
                                        ></i>
                                    </div>
                                    <div>
                                        <h6 class="m-0 font-semibold">
                                            Order <span>#2254</span> is placed
                                        </h6>

                                        <span class="text-sm text-700"
                                            >Total Amount of
                                            <span class="font-semibold"
                                                >$34.50</span
                                            ></span
                                        >
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a
                                    class="py-2 px-3 flex gap-2 cursor-pointer hover:text-primary"
                                >
                                    <div
                                        class="flex align-items-center justify-content-center border-1 border-circle border-transparent bg-cyan-100 text-500"
                                        style="height: 30px; width: 30px"
                                    >
                                        <i
                                            class="pi pi-clock text-lg text-cyan-500"
                                        ></i>
                                    </div>
                                    <div>
                                        <h6 class="m-0 font-semibold">
                                            Meeting with <span>AF04</span> Team
                                        </h6>

                                        <span class="text-sm text-700"
                                            >Google Meets</span
                                        >
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a
                                    class="py-2 px-3 flex gap-2 cursor-pointer hover:text-primary"
                                >
                                    <div
                                        class="flex align-items-center justify-content-center border-1 border-circle border-transparent bg-pink-100 text-500"
                                        style="height: 30px; width: 30px"
                                    >
                                        <i
                                            class="pi pi-th-large text-lg text-pink-500"
                                        ></i>
                                    </div>
                                    <div>
                                        <h6 class="m-0 font-semibold">
                                            Task <span>#41</span> is complete
                                        </h6>

                                        <span class="text-sm text-700"
                                            >9 Remaining Tasks</span
                                        >
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a
                                    class="py-2 px-3 flex gap-2 cursor-pointer hover:text-primary"
                                >
                                    <div
                                        class="flex align-items-center justify-content-center border-1 border-circle border-transparent bg-blue-100 text-500"
                                        style="height: 30px; width: 30px"
                                    >
                                        <i
                                            class="pi pi-shopping-cart text-lg text-blue-500"
                                        ></i>
                                    </div>
                                    <div>
                                        <h6 class="m-0 font-semibold">
                                            Order <span>#2255</span> is placed
                                        </h6>

                                        <span class="text-sm text-700"
                                            >Total Amount of
                                            <span class="font-semibold"
                                                >$40.45</span
                                            ></span
                                        >
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>-->
                <!-- Messaggi <li>
                    <a
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="fadeout"
                        [hideOnOutsideClick]="true"
                        pRipple
                    >
                        <i class="pi pi-comments" pBadge value="6"></i>
                    </a>
                    <div class="layout-topbar-menu shadow-2 hidden pt-0">
                        <ul class="list-none p-0 m-0 flex flex-column">
                            <li
                                class="flex justify-content-between align-items-center p-3 mb-3 cursor-pointer"
                            >
                                <h6 class="m-0 font-semibold">Messages</h6>
                                <span class="p-badge">5</span>
                            </li>
                            <li>
                                <a
                                    class="cursor-pointer flex align-items-center px-3 py-2 gap-3 hover:text-primary"
                                >
                                    <img
                                        src="assets/layout/images/dashboard/leader-1.png"
                                        class="w-2rem h-2rem"
                                    />
                                    <div>
                                        <h6 class="m-0 font-semibold">
                                            Hey! I sent the sales report
                                        </h6>
                                        <span class="text-sm text-700"
                                            >Dusana Semenov</span
                                        >
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a
                                    class="cursor-pointer flex align-items-center px-3 py-2 gap-3 hover:text-primary"
                                >
                                    <img
                                        src="assets/layout/images/dashboard/leader-2.png"
                                        class="w-2rem h-2rem"
                                    />
                                    <div>
                                        <h6 class="m-0 font-semibold">
                                            OK. Let’s meet at 15 pm...
                                        </h6>
                                        <span class="text-sm text-700"
                                            >Edward Lindgren</span
                                        >
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a
                                    class="cursor-pointer flex align-items-center px-3 py-2 gap-3 hover:text-primary"
                                >
                                    <img
                                        src="assets/layout/images/dashboard/leader-3.png"
                                        class="w-2rem h-2rem"
                                    />
                                    <div>
                                        <h6 class="m-0 font-semibold">
                                            Presentation is ready
                                        </h6>
                                        <span class="text-sm text-700"
                                            >Noell Blue</span
                                        >
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a
                                    class="cursor-pointer flex align-items-center px-3 py-2 gap-3 hover:text-primary"
                                >
                                    <img
                                        src="assets/layout/images/dashboard/leader-4.png"
                                        class="w-2rem h-2rem"
                                    />
                                    <div>
                                        <h6 class="m-0 font-semibold">
                                            Faulty delivery on #959
                                        </h6>
                                        <span class="text-sm text-700"
                                            >Gvozden Boskovsky</span
                                        >
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>-->
                <!-- Settings <li>
                    <a
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="fadeout"
                        [hideOnOutsideClick]="true"
                        pRipple
                    >
                        <i class="pi pi-cog"></i>
                    </a>
                    <div
                        class="layout-topbar-menu shadow-2 pt-0 hidden cursor-pointer"
                    >
                        <ul class="list-none p-0 m-0">
                            <li
                                class="flex justify-content-between align-items-center px-3 p-3 mb-3"
                            >
                                <h6 class="m-0 font-semibold">Impostazioni</h6>
                            </li>
                            <li>
                                <a
                                    class="py-2 px-3 flex gap-2 align-items-center cursor-pointer"
                                >
                                    <div
                                        class="flex align-items-center justify-content-center border-1 border-circle border-transparent bg-blue-100 text-500"
                                        style="height: 30px; width: 30px"
                                    >
                                        <i
                                            class="pi pi-user text-lg text-blue-500"
                                        ></i>
                                    </div>
                                    <h6 class="m-0 font-semibold">
                                        Anagrafica
                                    </h6>
                                </a>
                            </li>

                            <li>
                                <a
                                    class="py-2 px-3 flex gap-2 align-items-center cursor-pointer"
                                >
                                    <div
                                        class="flex align-items-center justify-content-center border-1 border-circle border-transparent bg-pink-100 text-500"
                                        style="height: 30px; width: 30px"
                                    >
                                        <i
                                            class="pi pi-bell text-lg text-pink-500"
                                        ></i>
                                    </div>
                                    <h6 class="m-0 font-semibold">
                                        Privacy
                                    </h6>
                                </a>
                            </li>
                            <li>
                                <a
                                    class="py-2 px-3 flex gap-2 align-items-center cursor-pointer"
                                >
                                    <div
                                        class="flex align-items-center justify-content-center border-1 border-circle border-transparent bg-blue-100 text-500"
                                        style="height: 30px; width: 30px"
                                    >
                                        <i
                                            class="pi pi-lock text-lg text-blue-500"
                                        ></i>
                                    </div>
                                    <h6 class="m-0 font-semibold">
                                        Impostazioni login
                                    </h6>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>-->
                <li class="layout-topbar-profile">
                    <a
                        *ngIf="!layoutService.isMobile()"
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="fadeout"
                        [hideOnOutsideClick]="true"
                    >
                        <div class="flex gap-2">
                            <i class="pi pi-user" style="font-size: 2.5rem"></i>
                            <div class="flex flex-column">
                                <span class="font-semibold">{{ nome }}</span>
                                <span class="text-sm">{{ ruolo | translate }}</span>
                            </div>
                        </div>
                    </a>
                    <div class="layout-topbar-menu p-0 shadow-2 hidden">
                        <ul class="list-none p-0 m-0">
                            <li class="mb-2">
                                <div class="flex gap-3 p-3 bg-primary-600">
                                 <i class="pi pi-user" style="color: white; font-size: 2.5rem"></i>

                                    <div class="flex flex-column cursor-pointer">
                                        <span class="font-semibold text-white">{{ nome }}</span>
                                        <span class="text-xs font-normal text-white">{{ ruolo }}</span>
                                    </div>
                                </div>
                            </li>
                            <li class="py-3 px-4 cursor-pointer" *ngIf="this.ruolo == 'paziente' || this.ruolo == 'medico'">
                                <a (click)="goToProfilo()" class="flex items-center gap-2 w-full h-full">
                                    <i class="pi pi-cog pi-star text-lg mt-2"></i>
                                    <span class="font-semibold mx-3">{{ 'Dati personali' | translate }}</span>
                                </a>
                            </li>

                            <li class="py-3 px-4 cursor-pointer"  *ngIf="this.ruolo != 'paziente'">
                                <a (click)="goToCambiapassword()" class="flex items-center gap-2 w-full h-full">
                                    <i class="pi pi-key text-lg mt-2"></i>
                                    <span class="font-semibold mx-3">{{ 'Cambia password' | translate }}</span>
                                </a>
                            </li>

                            <li class="py-3 px-4 flex gap-2 cursor-pointer" *ngIf="this.ruolo == 'paziente'" >
                                <a (click)="goToModificaConsensi()" class="flex items-center gap-2 w-full h-full">
                                    <i class="pi pi-key text-lg mt-2"></i>
                                    <span class="font-semibold mx-3">{{ 'Modifica consensi' | translate }}</span>
                                </a>
                            </li>

                            <li class="py-3 px-4 flex gap-2 cursor-pointer" *ngIf="this.ruolo == 'paziente'" >
                                <a (click)="goToPrivacyConsulto()" class="flex items-center gap-2 w-full h-full">
                                    <i class="pi pi-eye-slash text-lg mt-2"></i>
                                    <span class="font-semibold mx-3">{{ 'Privacy del consulto' | translate }}</span>
                                </a>
                            </li>

                            <li class="py-3 px-4 flex gap-2 cursor-pointer" *ngIf="this.ruolo == 'paziente'" >
                                <a>
                                    <i
                                            class="pi pi-flag text-lg mt-2"
                                    ></i>
                                    <span class="font-semibold mx-3">{{ 'Lingua' | translate }}</span>

                                </a>
                                <select [(ngModel)]="selectedLanguage"  (change)="onLanguageChange($event)">
                                    <option value="it">🇮🇹 Italiano</option>
                                    <option value="en">🇬🇧 English</option>
                                </select>


                            </li>
                            <li class="py-3 px-4 flex gap-2 cursor-pointer">
                                <a (click)="dialog()" class="flex items-center gap-2 w-full h-full">
                                    <i
                                        class="pi pi-power-off pi-image text-lg"
                                    ></i>
                                    <span class="font-semibold mx-3"
                                        >{{ 'Esci' | translate }}</span
                                    >
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
               <!-- <li class="layout-rightpanel-button">
                    <a
                        (click)="
                            layoutService.state.rightMenuActive =
                                !layoutService.state.rightMenuActive
                        "
                    >
                        <i class="pi pi-arrow-left"></i>
                    </a>
                </li>-->
            </ul>
        </div>
    </div>


    <p-dialog
            [(visible)]="showDialog"
            header="Conferma"
            [modal]="true"
            [style]="{ width: '450px' }"
    >
        <div class="flex align-items-center justify-content-center">
            <i
                    class="pi pi-exclamation-triangle mr-3"
                    style="font-size: 2rem"
            ></i>
            <span>{{ 'Sicuro di voler uscire' | translate }}?</span>
        </div>
        <ng-template pTemplate="footer">
            <button
                    pButton
                    pRipple
                    icon="pi pi-times"
                    class="p-button-text"
                    label="No"
                    (click)="showDialog = false"
            ></button>
            <button
                    pButton
                    pRipple
                    icon="pi pi-check"
                    class="p-button-text"
                    label="Sì"
                    (click)="logout()"
            ></button>
        </ng-template>
    </p-dialog>

</div>

